<div class="modal-header">
    <h5 class="modal-title">{{ title }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
    <p>{{ message }}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancel()">No</button>
    <button type="button" class="btn btn-outline-dark" (click)="confirm()">Yes</button>
</div>
